export type BriefFieldName = 'goal' | 'offer' | 'target' | 'geo' | 'channel' | 'dates';

export type BriefSource = 'from_call' | 'from_website' | 'assumed' | 'edited_by_you' | 'edited_by_skylarq';

export const BRIEF_FIELD_LABELS: Record<BriefFieldName, string> = {
  goal: 'Goal',
  offer: 'Offer',
  target: 'Target',
  geo: 'Geo',
  channel: 'Channel',
  dates: 'Dates',
};

/** What the API accepts per field, mirroring ProjectBriefUpdateRequest. */
export const BRIEF_FIELD_MAX_LENGTH: Record<BriefFieldName, number> = {
  goal: 2000,
  offer: 2000,
  target: 2000,
  geo: 500,
  channel: 50,
  dates: 500,
};

/** Where a brief field's value came from, in the words the client sees. */
export const BRIEF_SOURCE_LABELS: Record<BriefSource, string> = {
  from_call: 'from what you told us',
  from_website: 'from your website',
  assumed: 'assumed',
  edited_by_you: 'edited by you',
  edited_by_skylarq: 'edited by Skylarq',
};

export type BriefChannel = 'email' | 'linkedin';

export const BRIEF_CHANNEL_LABELS: Record<BriefChannel, string> = { email: 'Email', linkedin: 'LinkedIn' };

/** A brief value as shown: channel ids become their names, everything else reads as typed. */
export const briefValueLabel = (field: BriefFieldName, value: string): string =>
  field === 'channel' ? BRIEF_CHANNEL_LABELS[value as BriefChannel] ?? value : value;
